import { css } from '@/styled-system/css';

// CMS hero wrappers (e.g. `.jlvSHa a:not(StyledButton,StyledTextButton)`) force
// descendant color on CMS-rendered blocks. Apply this class to defeat that and
// let the element inherit its color from its Constellation parent.
export const inheritColorClass = css({ color: 'inherit' });
